export default __webpack_public_path__ + "static/media/master-plan.6d2c2d01.svg";